import React from "react";
import { useSearchParams } from "react-router-dom";
import {
  getMockPayloadForScenario,
  getMockScenarioOptions,
  MockScenarioKey,
} from "./mockMetadata";

export const useBeforeAfterMockMode = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isTestMode = searchParams.has("test");
  const scenarioOptions = React.useMemo(() => getMockScenarioOptions(), []);
  const initialScenario = (searchParams.get("scenario") ||
    "paired-balanced") as MockScenarioKey;
  const [selectedMockScenario, setSelectedMockScenario] =
    React.useState<MockScenarioKey>(initialScenario);

  React.useEffect(() => {
    if (!isTestMode) return;
    if (scenarioOptions.some((option) => option.key === selectedMockScenario)) {
      return;
    }
    setSelectedMockScenario("paired-balanced");
  }, [isTestMode, selectedMockScenario, scenarioOptions]);

  React.useEffect(() => {
    if (!isTestMode) return;
    if (
      searchParams.get("test") &&
      searchParams.get("scenario") === selectedMockScenario
    ) {
      return;
    }
    const nextParams = new URLSearchParams(searchParams.toString());
    nextParams.set("test", "1");
    nextParams.set("scenario", selectedMockScenario);
    setSearchParams(nextParams, { replace: true });
  }, [isTestMode, selectedMockScenario, setSearchParams]);

  const getSelectedScenarioPayload = React.useCallback(
    async () => getMockPayloadForScenario(selectedMockScenario),
    [selectedMockScenario],
  );

  return {
    isTestMode,
    scenarioOptions,
    selectedMockScenario,
    setSelectedMockScenario,
    getSelectedScenarioPayload,
  };
};
